import Vue from "vue"
import App from "./App.vue"
import "./registerServiceWorker"
import "./exception/errorHandler"
import router from "./router"
import store from "./store"
import http from "./services/http"
import SwalPlugin from "./plugins/Swal"
import MomentPlugin from "./plugins/Moment"
import UuidPlugin from "./plugins/Uuid"
import indicativePlugin from "./plugins/Indicative"
import StyleRouteItemPlugin from "./plugins/ColorCardRouteItem"
import { library } from "@fortawesome/fontawesome-svg-core"
import { Can } from "@casl/vue"
import { Ability } from "@casl/ability"
import { abilitiesPlugin } from "@casl/vue"
import Sidenav from "./components/Drawer/Sidenav.vue"
import NavBar from "./components/Drawer/NavBar.vue"
import Bonus from "./components/Dashboard/Bonus.vue"
import ModuleCs from "./components/FormRouteItem/ModuleCs.vue"
import ElectromechanicalMeter from "./components/FormRouteItem/ElectromechanicalMeter.vue"
import CustomSanitizor from "./CustomSanitizor"
import CustomValidations from "./CustomValidation"
//@ts-ignore
import VueMask from "v-mask"
import VueMeta from "vue-meta"

import BootstrapVue from "bootstrap-vue"
import {
  faUserSecret,
  faChartBar,
  faTruckMoving,
  faUsers,
  faWrench,
  faEye,
  faParachuteBox,
  faBriefcase,
  faClipboardList,
  faUsersCog,
  faCoins,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons"
//@ts-ignore
import CanMixin from "./mixins/can.js"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
const UpdateStoreMixin = require("./mixins/updateStore.js").default
const { ClientTable } = require("vue-tables-2")

import "./filters/index"

library.add(
  faUserSecret,
  faChartBar,
  faTruckMoving,
  faUsers,
  faEye,
  faWrench,
  faParachuteBox,
  faBriefcase,
  faClipboardList,
  faUsersCog,
  faCoins,
  faTimesCircle
)

Vue.prototype.$http = http()

// Componentes
Vue.component("Can", Can)
Vue.component("menu-sidenav", Sidenav)
Vue.component("module-cs", ModuleCs)
Vue.component("electromechanical-meter", ElectromechanicalMeter)
Vue.component("menu-navbar", NavBar)
Vue.component("Bonus", Bonus)
Vue.component("icon-awesome", FontAwesomeIcon)

const ability = new Ability([])

// Vue.use(KsComponent)
Vue.use(VueMask)
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
})
Vue.use(ClientTable)
Vue.use(abilitiesPlugin, ability)
Vue.use(StyleRouteItemPlugin)
Vue.use(UuidPlugin)
Vue.use(SwalPlugin)
Vue.use(indicativePlugin, {
  validations: CustomValidations,
  sanitizor: CustomSanitizor,
})
Vue.use(MomentPlugin)
Vue.use(BootstrapVue)

// Global RTL flag
Vue.mixin({
  data: () => require("./globals.js").default(),
})

Vue.config.productionTip = false

Vue.mixin(UpdateStoreMixin)
new Vue({
  router,
  store,
  mixins: [CanMixin],
  render: h => h(App),
}).$mount("#app")
